<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">{{ $i18n.t("machinemente.title") }}</h1>
    <b-tabs content-class="mt-3">
      <b-tab :title="this.$i18n.t('machinemente.tab_search')" active>
        <b-card class="w-50 mb-3">
          <form>
            <b-form-group
              id="machineIdSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('machinemente.label_machine_id')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="machineIdSearch" :placeholder="this.$i18n.t('machinemente.placeholder_machine_id')"></b-form-input>
            </b-form-group>
            <b-form-group
              id="machineNameSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('machinemente.label_machine_name')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="machineNameSearch" :placeholder="this.$i18n.t('machinemente.placeholder_machine_name')"></b-form-input>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="search" class="float-right px-5">{{ $i18n.t("machinemente.button_search") }}</b-button>
            </div>
          </form>
        </b-card>
        <b-card v-if="isSearch">
          <b-row class="d-flex align-items-center">
            <b-col sm="2" md="2" class="my-1">
              <b-dropdown right variant="primary" :text="lblAction">
                <b-dropdown-item @click="changeValidStatus('1')" >{{ $i18n.t("machinemente.button_valid") }}</b-dropdown-item>
                <b-dropdown-item @click="changeValidStatus('0')" >{{ $i18n.t("machinemente.button_invalid") }}</b-dropdown-item>
                <b-dropdown-item @click="download(1)" >{{ $i18n.t("machinemente.download_barcode") }}</b-dropdown-item>
                <b-dropdown-item @click="download(2)" >{{ $i18n.t("machinemente.download_qrcode") }}</b-dropdown-item>
              </b-dropdown>
            </b-col>
            <b-col sm="2" md="2" class="my-1">
              <div>{{ $i18n.t("machinemente.label_num_of_disp") }}
                <b-form-select
                  v-model="perPage"
                  id="perPageSelect"
                  :options="pageOptions"
                  style="width: auto"
                ></b-form-select>
              </div>
            </b-col>
            <b-col sm="8" md="8" class="my-1">
              <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
          <b-table
            :striped="striped"
            :bordered="bordered"
            :borderless="borderless"
            :outlined="outlined"
            :current-page="currentPage"
            :per-page="perPage"
            :small="small"
            :hover="hover"
            :dark="dark"
            :fixed="fixed"
            :foot-clone="footClone"
            :no-border-collapse="noCollapse"
            :items="items"
            :fields="fields"
            :head-variant="headVariant"
            :table-variant="tableVariant"
            :tbody-tr-class="rowClass"
          >
            <template v-slot:head(action)="row">
              <b-form inline>
                <b-form-checkbox size="lg" :checked="isAllSelected" v-on:change="selectAll" name="check-button"></b-form-checkbox>
              </b-form>
            </template>
            <template v-slot:cell(action)="row">
              <b-form-checkbox size="lg" v-model="row.item.selectedFlg" v-on:change="selectOne(row.item.index)" name="check-button"></b-form-checkbox>
            </template>
            <template v-slot:cell(edit)="row">
              <b-button v-if="row.item.efFlg === '1'" size="sm" class="mr-2" @click="edit(row.item, row.index, $event.target)">{{ $i18n.t("machinemente.button_edit") }}</b-button>
              <b-button v-if="row.item.efFlg === '0'" disabled=true size="sm" class="mr-2" >{{ $i18n.t("machinemente.button_edit") }}</b-button>
            </template>
          </b-table>
        </b-card>
      </b-tab>
      <!-- 新規登録 -->
      <b-tab :title="this.$i18n.t('machinemente.tab_register')">
        <b-card class="w-50">
          <form>
            <b-form-group
              id="machineId"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('machinemente.label_machine_id_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="machineId" maxlength="4" :placeholder="this.$i18n.t('machinemente.placeholder_machine_name')"></b-form-input>
            </b-form-group>
            <b-form-group
              id="machineName"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('machinemente.label_machine_name_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="machineName" maxlength="40" :placeholder="this.$i18n.t('machinemente.placeholder_machine_name')"></b-form-input>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="regist" class="float-right px-5">{{ $i18n.t("machinemente.button_register") }}</b-button>
            </div>
          </form>
        </b-card>
      </b-tab>
      <b-tab :title="this.$i18n.t('machinemente.tab_disp_order')" @click="createdDispNumChange">
        <b-card class="w-50">
          <form>
            <b-form-group
              id="dispNumList"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('machinemente.label_disp_order')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="machineSelected" :options="dispNumOptions" :select-size="10" ></b-form-select>
              <b-button variant="secondary" class="float-right px-5" @click="downDisp">{{ $i18n.t("machinemente.button_down") }}</b-button>
              <b-button variant="secondary" class="float-right px-5" @click="upDisp">{{ $i18n.t("machinemente.button_up") }}</b-button>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="regist2" class="float-right px-5">{{ $i18n.t("machinemente.button_disp_order") }}</b-button>
            </div>
          </form>
        </b-card>
      </b-tab>
    </b-tabs>
    <confirm-modal modId="md-confirm" :msg="this.$i18n.t('machinemente.info_register')" :titleMsg="this.$i18n.t('machinemente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="registConfirm"/>
    <confirm-modal modId="md-confirm2" :msg="this.$i18n.t('machinemente.info_disp_order')" :titleMsg="this.$i18n.t('machinemente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="registConfirm2"/>
    <confirm-modal modId="md-confirm3" :msg="this.$i18n.t('machinemente.info_valid')" :titleMsg="this.$i18n.t('machinemente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="validConfirm"/>
    <confirm-modal modId="md-confirm4" :msg="this.$i18n.t('machinemente.info_invalid')" :titleMsg="this.$i18n.t('machinemente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="invalidConfirm"/>
    <confirm-modal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'

export default {
  components: {
    confirmModal
  },
  created () {
    var headers = {
      'Content-Type': 'application/json',
      'opId': this.$store.store.state.opId,
      'ticketId': this.$store.store.state.ticketId
    }

    var body = {}

    document.body.style.overflow = 'hidden'
    this.$store.store.state.loading = true
    this.$axios
      .post(window.END_POINT + '/common/checkLogin', body, {
        'headers': headers
      })
      .then(res => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        console.log(res)
        if (res.data.result !== 'OK') {
          if (res.data.result === '401') {
            // ログインしていない場合
            this.$router.push('/')
          } else {
            this.errSbj = this.$i18n.t('common.title_modal_error')
            this.errMsg = this.$i18n.t(res.data.message)
            this.$bvModal.show('md-err')
          }
        }
      })
      .catch(res => {
        // とりあえずログイン画面へ飛ばす
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        console.log(res)
        this.$router.push('/')
      })

    // 更新画面から戻った場合は再検索
    var searchFlg = this.$route.query.searchFlg
    if (searchFlg !== undefined) {
      if (searchFlg[0] === 1) {
        // 配列として渡されてしまうため先頭の値のみ取得
        var searchMachineId = this.$route.query.searchMachineId
        this.machineIdSearch = searchMachineId[0]
        var searchMachineName = this.$route.query.searchMachineName
        this.machineNameSearch = searchMachineName[0]
        this.search()
      }
    }
  },
  data () {
    return {
      machineIdSearch: '',
      machineNameSearch: '',
      isAllSelected: false,
      machineId: null,
      machineName: null,
      machineSelected: null,
      currentPage: 1,
      pageOptions: [10, 20, 50, 100],
      perPage: 10,
      totalRows: 0,
      fields: [
        { key: 'action', label: '' },
        { key: 'machineId', label: this.$i18n.t('machinemente.label_machine_id'), sortable: true },
        { key: 'machineName', label: this.$i18n.t('machinemente.label_machine_name'), sortable: true },
        { key: 'uOp', label: this.$i18n.t('machinemente.label_register_user'), sortable: true },
        { key: 'uDate', label: this.$i18n.t('machinemente.label_register_date'), sortable: true },
        { key: 'efFlgStr', label: this.$i18n.t('machinemente.label_ef_flg'), sortable: true },
        { key: 'edit', label: this.$i18n.t('machinemente.label_edit') }
      ],
      items: [
      ],
      selectedItems: [
      ],
      dispNumOptions: [
      ],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      noCollapse: true,
      isSearch: false,
      errMsg: '',
      errSbj: '',
      lblAction: this.$i18n.t('machinemente.button_action')
    }
  },
  methods: {
    search: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      // 入力値を設定
      body.machineId = this.machineIdSearch
      body.machineIdLikeFlg = '1'
      body.machineName = this.machineNameSearch
      body.efFlg = ''

      // 設備取得
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/machine/select', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var machineInfoList = res.data.machineInfo
            var items = []

            if (machineInfoList.length === 0) {
              this.errSbj = this.$i18n.t('machinemente.title')
              this.errMsg = this.$i18n.t('machinemente.err_not_data')
              this.$bvModal.show('md-err')
              this.isSearch = false
              return
            }

            // 整形
            for (var i = 0; i < machineInfoList.length; i++) {
              var item = {}
              item.machineId = machineInfoList[i].machine_id
              item.machineName = machineInfoList[i].machine_name
              item.uOp = machineInfoList[i].u_op_name
              // utc -> local 変換
              // momentオブジェクト(UTC)に変換
              var utc = this.$moment.utc(machineInfoList[i].u_date, 'YYYY-MM-DD HH:mm:ss')
              if (String(utc) === 'Invalid date') {
                item.uDate = ''
              } else {
                // local時刻に変換＆フォーマット
                item.uDate = utc.local().format('YYYY-MM-DD HH:mm:ss')
              }
              item.efFlg = machineInfoList[i].ef_flg
              if (item.efFlg === '1') {
                item.efFlgStr = this.$i18n.t('codemente.label_valid')
              } else {
                item.efFlgStr = this.$i18n.t('codemente.label_invalid')
                item.status = 'awesome'
              }
              item.selectedFlg = false
              // 選択状態書き換え時に使用するindex
              item.index = i
              items.push(item)
            }
            // ページング設定
            this.totalRows = items.length
            // 一旦データクリア
            this.items.splice(0)
            // データセット
            this.items.splice(0, 0, ...items)
            // 検索結果表示
            this.isSearch = true
            // 全選択チェック
            this.isAllSelected = false
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    regist: function () {
      // 入力値チェック
      if (this.machineId === null || this.machineId === '') {
        this.errSbj = this.$i18n.t('machinemente.title')
        this.errMsg = this.$i18n.t('machinemente.err_machine_id_hissu')
        this.$bvModal.show('md-err')
        return
      }
      if (this.machineName === null || this.machineName === '') {
        this.errSbj = this.$i18n.t('machinemente.title')
        this.errMsg = this.$i18n.t('machinemente.err_machine_name_hissu')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkNum(this.machineId)) {
        this.errSbj = this.$i18n.t('machinemente.title')
        this.errMsg = this.$i18n.t('machinemente.err_machine_id_number')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkProhibitedLetters(this.machineName)) {
        this.errSbj = this.$i18n.t('machinemente.title')
        this.errMsg = this.$i18n.t('machinemente.err_machine_name_symbol')
        this.$bvModal.show('md-err')
        return
      }

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      // 入力値を設定
      body.machineId = this.machineId
      body.machineName = this.machineName

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/machine/register', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            // 登録メッセージ表示
            this.$bvModal.show('md-confirm')
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    regist2: function () {
      // 表示順変更
      var machineId = []
      for (var i = 0; i < this.dispNumOptions.length; i++) {
        machineId.push(String(this.dispNumOptions[i].value))
      }
      var body = {}
      body.machineId = machineId

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/machine/updateDispOrder', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              // エラー表示
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.$bvModal.show('md-confirm2')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    registConfirm: function () {
      this.machineId = null
      this.machineName = null
      this.$bvModal.hide('md-confirm')
    },
    registConfirm2: function () {
      this.$bvModal.hide('md-confirm2')
    },
    changeValidStatus: function (mode) {
      // mode='1':有効、mode='0':無効
      this.selectedItems.splice(0)
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].selectedFlg) {
          var selectedItem = this.items[i].machineId
          this.selectedItems.push(String(selectedItem))
        }
      }
      if (this.selectedItems.length === 0) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('machinemente.err_not_selected')
        this.$bvModal.show('md-err')
        return
      }
      var body = {}
      body.mode = mode
      body.machineId = this.selectedItems

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/machine/updateEfFlg', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.search()
            if (mode === '1') {
              // 有効
              this.$bvModal.show('md-confirm3')
            } else {
              // 無効
              this.$bvModal.show('md-confirm4')
            }
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    download: function (flg) {
      this.selectedItems.splice(0)
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].selectedFlg) {
          this.selectedItems.push(this.items[i].machineId)
        }
      }

      if (this.selectedItems.length === 0) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('machinemente.err_not_selected')
        this.$bvModal.show('md-err')
        return
      }

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }
      // 行数列数等は仮で固定
      var body = {}
      body.machineId = this.selectedItems
      body.startRow = 1
      body.startColumn = 1
      body.barKind = flg
      body.column = 4
      if (flg === 1) {
        body.row = 15
      } else {
        body.row = 8
      }
      body.language = this.$store.store.getters.getLang
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/machine/barcode', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            console.log(res)
            var fileName = 'machinemente_' + this.$moment().format('YYYYMMDDHHmmss')
            console.log(fileName)
            this.downloadPdf(res.data.url, fileName)
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    downloadPdf: function (url, fileName) {
      this.$axios
        .get(url, {
          responseType: 'blob',
          dataType: 'binary'
        })
        .then(res => {
          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(res.data, fileName + '.pdf')
          } else {
            // for chrome, firefox
            const url = URL.createObjectURL(
              new Blob([res.data], {type: 'application/pdf'})
            )
            const linkEl = document.createElement('a')
            linkEl.href = url
            linkEl.setAttribute('download', fileName + '.pdf')
            document.body.appendChild(linkEl)
            linkEl.click()
            URL.revokeObjectURL(url)
            linkEl.parentNode.removeChild(linkEl)
          }
        })
        .catch(res => {
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    validConfirm: function () {
      this.$bvModal.hide('md-confirm3')
    },
    invalidConfirm: function () {
      this.$bvModal.hide('md-confirm4')
    },
    edit: function (item, index, button) {
      // 検索結果保持(戻るボタン対応)
      this.$store.store.state.searchMachineId = this.machineIdSearch
      this.$store.store.state.searchMachineName = this.machineNameSearch

      // 編集データ
      this.$store.store.state.editid = item.machineId.toString()
      this.$router.push({ path: 'machinementeEdit' })
    },
    rowClass: function (item, type) {
      if (!item) return
      if (item.status === 'awesome') return 'table-danger'
    },
    createdDispNumChange () {
      var body = {}

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/machine/select', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              // エラー表示
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            // 表示順整形
            var machineInfoList = res.data.machineInfo
            var dispNumOptions = []
            for (var i = 0; i < machineInfoList.length; i++) {
              var dispNumOption = {}
              dispNumOption.value = machineInfoList[i].machine_id
              dispNumOption.text = machineInfoList[i].machine_name
              dispNumOptions.push(dispNumOption)
            }
            this.dispNumOptions.splice(0)
            this.dispNumOptions.splice(0, 0, ...dispNumOptions)
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    downDisp: function () {
      if (this.machineSelected === null) {
        return
      }
      // iで表示順を取得
      for (var i = 0; i < this.dispNumOptions.length; i++) {
        if (this.machineSelected === this.dispNumOptions[i].value) {
          break
        }
      }
      // 順序を入れ替え
      var selectedMachineInfo = this.dispNumOptions[i]
      if (i !== (this.dispNumOptions.length - 1)) {
        var exchangeMachineInfo = this.dispNumOptions[i + 1]
        this.dispNumOptions.splice(i, 1, exchangeMachineInfo)
        this.dispNumOptions.splice(i + 1, 1, selectedMachineInfo)
      }
    },
    upDisp: function () {
      if (this.machineSelected === null) {
        return
      }
      // iで表示順を取得
      for (var i = 0; i < this.dispNumOptions.length; i++) {
        if (this.machineSelected === this.dispNumOptions[i].value) {
          break
        }
      }
      // 順序を入れ替え
      var selectedMachineInfo = this.dispNumOptions[i]
      if (i !== 0) {
        var exchangeMachineInfo = this.dispNumOptions[i - 1]
        this.dispNumOptions.splice(i, 1, exchangeMachineInfo)
        this.dispNumOptions.splice(i - 1, 1, selectedMachineInfo)
      }
    },
    selectAll () {
      if (this.isAllSelected) {
        this.isAllSelected = false
        for (var i = 0; i < this.items.length; i++) {
          this.items[i].selectedFlg = false
        }
      } else {
        this.isAllSelected = true
        for (var j = 0; j < this.items.length; j++) {
          this.items[j].selectedFlg = true
        }
      }
    },
    selectOne (index) {
      this.items[index].selectedFlg = !this.items[index].selectedFlg
      var selectedCnt = 0
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].selectedFlg) {
          selectedCnt++
        }
      }
      if (selectedCnt !== this.items.length) {
        this.isAllSelected = false
      } else {
        this.isAllSelected = true
      }
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Machinemente.vue